import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getToken, getUserInfo } from './authentication';
import { useCookies } from 'react-cookie';

export const AuthContext = React.createContext<any>({});

export const IS_AUTHENTICATED_COOKIE = 'IS_AUTHENTICATED';
export const IS_AUTHENTICATED_VALUE = 'TRUE';

const USERINFO_STORAGE_KEY = 'userInfo'

const Auth = ({ children }) => {
    const [cookies, setCookie] = useCookies([IS_AUTHENTICATED_COOKIE]);

    const checkIsAuthenticated = (): boolean => cookies[IS_AUTHENTICATED_COOKIE] === IS_AUTHENTICATED_VALUE && userInfo() !== null;

    const userInfo = () => {
        const info = sessionStorage.getItem(USERINFO_STORAGE_KEY);
        try {
            return info ? JSON.parse(info) : null;
        } catch (err) {
            console.error(`userInfo data error; ${err}`);
        }
        return null;
    };

    const authenticateUser = async (urlParams) => {
        let userAuthenticated = false;
        let userInformation: object | null = null;
        try {
            const token = await getToken(urlParams);

            console.log('******************token****************=', token);
            if (token) {
                // todo: bh need to move this code away from shared-service,
                if (typeof token === 'string') {
                    sessionStorage.setItem('access_token', token);
                }
                // todo end
                const tokenUserInfo = await getUserInfo();
                if (tokenUserInfo) {
                    setCookie(IS_AUTHENTICATED_COOKIE, IS_AUTHENTICATED_VALUE, {
                        path: process.env.REACT_APP_PUBLIC_URL,
                        secure: true,
                        sameSite: 'strict',
                    });

                    userInformation = tokenUserInfo;
                    userAuthenticated = true;
                }
            }
            sessionStorage.setItem(USERINFO_STORAGE_KEY, userInformation ? JSON.stringify(userInformation) : '');
            return userAuthenticated;
        } catch (err) {
            console.log('****************** token-error ****************=', err);
            localStorage.clear();
            sessionStorage.clear();
            return false;
        }
    };

    return <AuthContext.Provider value={{ checkIsAuthenticated, authenticateUser, userInfo }}>{children}</AuthContext.Provider>;
};

Auth.propTypes = {
    children: PropTypes.node.isRequired,
};

export default memo(Auth);
